import FileUpload from './file-upload-input';
import File from './file';
import { getBase64, isFileImage } from './utils';
export { File, getBase64, isFileImage };
export default FileUpload;